export const fiData = `
<div class="paragraph">
    <div class="title">SOPIMUSEHDOT</div>
    <div class="text-box">
      <div class="text">
        <br><br>
        Tämä vaihto-ohjelmapalvelu ("Palvelu") tarjotaan yrityksen Danghuan Europe S.L.
        toimesta. Yhtiö on perustettu Espanjan lain mukaisesti ja rekisteröity osoitteessa Madrid,
        Espanja (28045), ALV-tunnus B19961911 (jäljempänä “Danghuan”), sähköpostiosoite:
        legal@danghuan.eu.
        ONEPLUS-yhtiöt – Reflection Investment B.V. (Espanja ja Ranska) sekä Unumplus
        Limited (Yhdistynyt kuningaskunta) – edistävät tämän vaihto-ohjelmapalvelun
        saatavuutta virallisilla verkkosivustoillaan. ONEPLUS ei kuitenkaan hallinnoi, käsittele
        eikä operoi mitään osaa vaihto-ohjelmasta.
        <br><br>
        Tämä asiakirja määrittää ehdot, joiden mukaisesti Euroopan unionissa asuvat kuluttajat
        voivat osallistua viralliseen vaihto-ohjelmaan valittujen älypuhelinten oston yhteydessä.
        Ohjelma toteutetaan täysin Euroopan unionin lainsäädännön mukaisesti, erityisesti
        direktiivin 2011/83/EU (kuluttajansuoja) ja asetuksen (EU) 2016/679 (yleinen tietosuoja-
        asetus, GDPR) perusteella.
        <br><br>
        Yhdistyneessä kuningaskunnassa asuvien kuluttajien osalta vaihto-ohjelmaa
        sovelletaan soveltuvan Ison-Britannian lain mukaisesti, mukaan lukien Consumer Rights
        Act 2015 sekä UK General Data Protection Regulation (UK GDPR), joka perustuu
        asetukseen (EU) 2016/679 ja on sisällytetty Ison-Britannian lainsäädäntöön Data
        Protection Act 2018 -lain nojalla.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 1 – ALUEELLINEN SOVELTAMISALA JA TUOTTEET</strong>
        <br><br>
        1.1. Vaihto-ohjelmapalvelu on saatavilla kaikille vähintään 18-vuotiaille luonnollisille
        henkilöille, jotka asuvat laillisesti Euroopan unionin jäsenvaltiossa tai Yhdistyneessä
        kuningaskunnassa.
        <br><br>
        1.2. Asiakkaiden on toimittava yksityishenkilöinä (ei ammattimaisesti) ja heidän on
        täytettävä kuluttajan määritelmä direktiivin 2011/83/EU (EU:n asukkaat) tai Consumer
        Rights Act 2015 (UK:n asukkaat) mukaisesti.
        <br><br>
        1.3. Jokaisessa hyväksytyssä vaihto-operaatiossa voidaan vaihtaa vain yksi käytetty
        laite.
        <br><br>
        1.4. Palvelu on saatavilla yksinomaan asiakkaille, jotka ostavat kelpoisen ONEPLUS-
        tuotteen (“Tuote”) virallisten ONEPLUS-verkkokauppojen kautta Ranskassa,
        Espanjassa tai Yhdistyneessä kuningaskunnassa kampanja-ajan kuluessa. Vain tietyt
        ONEPLUS-mallit ovat kelpoisia ohjelmaan.
        <br><br>
        1.5. Vaihdettava laite on oltava virallisella verkkosivustolla julkaistulla hyväksyttyjen
        mallien listalla ja sen on täytettävä toiminnallisuus- ja omistusehdot, jotka on määritelty
        artiklassa 5.
        <br><br>
        1.6. Asiakas voi toimittaa vain yhden (1) käytetyn laitteen jokaista ostettua Tuotetta kohti.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 2 – SOPIMUKSELLISET EHDOT</strong>
        <br><br>
        2.1. Vaihto-ohjelmapalvelu toimii itsenäisesti eikä ole sidoksissa minkään tuotteen ostoon.
        Se ei muodosta yhdistettyä tai yhteistä tarjousta minkään laitteen valmistajan, jakelijan
        tai jälleenmyyjän kanssa.
        <br><br>
        2.2. Kaikki palvelun toiminnalliset vastuut — mukaan lukien asiakasviestintä, laitteen
        logistiikka, arvonmääritys, maksut ja henkilötietojen käsittely — kuuluvat yksinomaan
        yritykselle Danghuan Europe S.L.
        <br><br>
        2.3. Mikään näissä sopimusehdoissa ei rajoita eikä heikennä kuluttajalle sovellettavan
        lain perusteella kuuluvia lakisääteisiä oikeuksia, mukaan lukien, mutta ei rajoittuen,
        direktiiviin 2011/83/EU ja Ison-Britannian Consumer Rights Act 2015 -lakiin.
        <br><br>
        2.4. Danghuan pidättää oikeuden hylätä minkä tahansa vaihto-pyynnön, jos on
        perusteltu epäilys petoksesta, väärinkäytöstä tai ehtojen rikkomisesta, mukaan lukien
        tapaukset, joissa kolmas osapuoli tekee ilmoituksen toisen käyttäjän puolesta.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 3 – PALVELUUN OSALLISTUMISPROSESSI</strong>
        <br><br>
        3.1. Asiakas voi rekisteröityä vaihto-ohjelmapalveluun ONEPLUSin virallisessa
        verkkokaupassa tilaamisen yhteydessä.
        <br><br>
        3.2. Jatkaakseen prosessia asiakkaan on täytettävä itsearviointilomake ja toimitettava
        tarvittavat laitteen tiedot, mukaan lukien, mutta ei rajoittuen, IMEI-numero, malli ja
        laitteen kunto.
        <br><br>
        • Varmistathan, että vanhan laitteesi malli on valittu oikein. Jos muutoksia tarvitaan,
        ota meihin yhteyttä mahdollisimman pian osoitteessa insta360@danghuan.eu, jotta
        voimme päivittää laitteen tiedot.
        <br><br>
        3.3. Asiakkaan on ilmoitettava oikeat ja voimassa olevat pankkitiedot maksua varten
        rekisteröinnin yhteydessä:
        <br><br>
        • EU-/ETA-alueen asukkaille: SEPA-yhteensopiva IBAN-tilinumero, joka on myönnetty
        rahoituslaitoksessa SEPA-alueella.
        <br><br>
        • Yhdistyneen kuningaskunnan asukkaille: GBP-valuuttainen pankkitili asiakkaan
        nimissä, johon sisältyvät Sort Code ja Account Number, maksua varten Faster
        Payments- tai BACS-järjestelmällä.
        <br><br>
        3.4. Asiakas saa sähköpostitse ohjeet vaihto-ohjelman jatkamisesta 24 tunnin kuluessa
        siitä, kun uusi laite on merkitty toimitetuksi logistiikkajärjestelmään.
        <br><br>
        3.5. Asiakkaan on ladattava kaikki vaaditut asiakirjat (esimerkiksi allekirjoitettu
        rehellisyysvakuutus) ja lähetettävä käytetty laite 10 kalenteripäivän kuluessa uuden
        laitteen toimituspäivästä. Voimassa olevan seurantanumeron on osoitettava, että lähetys
        on aloitettu tämän määräajan kuluessa.
        <br><br>
        3.6. Mikäli yllä mainittuja vaiheita ei suoriteta määräajan kuluessa, vaihto-pyyntö
        perutaan automaattisesti.
        <br><br>
        3.7. Epätäydelliset, ristiriitaiset tai virheelliset ilmoitukset — kuten väärä IMEI-numero tai
        puuttuvat asiakirjat — voivat johtaa vaihto-ohjelman hylkäämiseen ilman korvausta.
        <br><br>
        3.8. Käytetty laite on pakattava turvallisesti annettujen lähetysohjeiden mukaisesti.
        Lähetys on ennakkoon maksettu Danghuanin toimesta. Jos toimitus epäonnistuu tai laite
        vahingoittuu kuljetuksen aikana, asiakkaan on otettava yhteyttä sähköpostitse
        insta360@danghuan.eu. 15 kalenteripäivän kuluessa viimeisestä seurannan
        päivityksestä. Danghuan antaa asiakkaalle pääsyn viralliseen UPS-vaatekanavaan ja
        auttaa vaatimuksen tekemisessä.
        <br><br>
        Huomautus: logistiikkavaatimukset on tehtävä 60 päivän kuluessa lähetysetiketin
        luomisesta. Mahdolliset hyväksytyt korvaukset maksetaan suoraan asiakkaan
        ilmoittamalle IBAN-tilille. Danghuan ei ole vastuussa korvauksista näissä tapauksissa.
        <br><br>
        3.9. Laitteita, jotka palautetaan ilman vaadittua rehellisyysvakuutusta tai allekirjoitettua
        myyntivahvistusta, ei käsitellä. Asiakkaalle ilmoitetaan sähköpostitse, ja hän voi pyytää
        laitteen palauttamista 10 kalenteripäivän kuluessa ilmoituksen vastaanottamisesta.
        Palautuksen toimituskulut määräytyvät artiklan 6.3 mukaisesti. Jos pyyntöä ei
        vastaanoteta määräajassa, Danghuan pidättää oikeuden kierrättää tai hävittää laitteen
        vastuullisesti ilman lisävelvoitteita.
        <br><br>
        3.10. Vaihto-ohjelmaan hyväksyttävät tuotteet sisältävät älypuhelimet, älykellot,
        langattomat kuulokkeet ja tabletit, jotka on lueteltu ja hyväksytty ONEPLUSin virallisella
        verkkosivustolla osallistumishetkellä.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 4 – LAITTEIDEN HYVÄKSYMISKRITEERIT</strong>
        <br><br>
        4.1. Vain ne laitteet, jotka sisältyvät ONEPLUSin virallisella verkkosivustolla julkaistuun
        kelpoisten mallien luetteloon (mukaan lukien älypuhelimet, älykellot, langattomat
        kuulokkeet ja tabletit), hyväksytään vaihto-ohjelmaan.
        <br><br>
        4.2. Kaikkien laitteiden on täytettävä Danghuanin määrittämät kuntoluokitukset ja
        ulkoiset laatuvaatimukset. Laitteet arvioidaan ja luokitellaan A-, B- tai C-luokkaan
        sertifioiduilla tarkastustyökaluilla ja niiden fyysisen kunnon perusteella, kuten kuvattu
        artiklassa 6.
        <br><br>
        4.3. Laitteiden on täytettävä seuraavat vähimmäisvaatimukset toiminnallisuuden ja
        kunnon osalta:
        <br><br>
        – Älypuhelimet ja tabletit: Laitteen on käynnistyttävä normaalisti, kosketusnäytön ja akun
        on toimittava, eikä siinä saa olla merkittäviä fyysisiä vaurioita (esim. haljennut näyttö,
        korroosio). Sen on oltava palautettu tehdasasetuksiin ja kaikki suojauslukot (esim. PIN,
        Apple iCloud, Google FRP, Samsung tai Xiaomi -tililukitus) on poistettava.
        <br><br>
        – Älykellot: Laitteen on käynnistyttävä, sen tulee olla vapautettu kaikista aktiivisista
        tililukituksista (esim. iCloud, Google, Samsung), ja sen on toimittava moitteettomasti
        ilman vakavia fyysisiä vaurioita.
        <br><br>
        – Langattomat kuulokkeet: Molempien kuulokkeiden ja latauskotelon on oltava mukana.
        Niiden on pystyttävä latautumaan ja yhdistymään, eikä niissä saa olla veden aiheuttamia
        vahinkoja tai rakenteellisia halkeamia.
        <br><br>
        4.4. Kaikkien laitteiden on oltava asiakkaan omaisuutta, eivätkä ne saa olla vuokra-,
        osamaksu- tai kolmannen osapuolen omistuksessa. Laitteet, jotka on ilmoitettu
        kadonneiksi, varastetuiksi, väärennetyiksi tai manipuloiduiksi (esimerkiksi muokattu
        sarjanumero tai IMEI), hylätään ilman korvausta.
        <br><br>
        4.5. Laitteet, jotka eivät täytä vähimmäiskelpoisuusvaatimuksia, voidaan asiakkaan
        pyynnöstä palauttaa 7 päivän kuluessa ilmoituksesta. Ilmoitus lähetetään sähköpostitse.
        Jos palautuspyyntöä ei tehdä määräajassa, laite voidaan kierrättää vastuullisesti.
        <br><br>
        Jos asiakas pyytää tällaisen ei-kelpoisen laitteen palauttamista, palautusprosessi ja
        toimituskustannukset määräytyvät artiklan 6.3 mukaisesti.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 5 – LOGISTIIKAN AIKATAULU JA VELVOLLISUUDET</strong>
        <br><br>
        5.1. Asiakkaan on lähetettävä käytetty laite 10 kalenteripäivän kuluessa uuden
        ONEPLUS-laitteen vastaanottamisesta.
        <br><br>
        5.2. Danghuan lähettää muistutussähköpostit Day 3 (D+3), Day 6 (D+6) ja Day 9 (D+9)
        toimituksen jälkeen.
        <br><br>
        5.3. Kaikkien laitteiden lähetykseen on käytettävä ennakkoon maksettua lähetysetikettiä,
        jonka tarjoaa Danghuan Europe S.L.
        <br><br>
        5.4. Jos lähetysetikettiä ei ole skannattu logistiikkapalveluntarjoajan toimesta Day 15
        (D+14) mennessä, vaihto-ohjelma perutaan automaattisesti.
        <br><br>
        5.5. Laitteet on pakattava turvallisesti kuljetusvaurioiden välttämiseksi; Danghuan antaa
        pakkausohjeet, mutta ei toimita fyysisiä pakkausmateriaaleja.
        <br><br>
        5.6. Mikäli vastaanotetun laitteen IMEI-numero ei vastaa ilmoitettua tai laitteen kunto
        poikkeaa ilmoitetusta, Danghuan voi tehdä arvonmuutoksen tai peruuttaa vaihto-
        ohjelman.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 6 – TARKASTUS, TARJOUS JA HYVÄKSYMINEN</strong>
        <br><br>
        6.1. Vastaanotetut laitteet tarkastetaan kolmen (3) arkipäivän kuluessa siitä, kun ne on
        toimitettu Danghuanin nimettyyn varastoon. Tarkastus sisältää sekä toiminnallisen
        diagnostiikan sertifioiduilla työkaluilla että visuaalisen arvion laitteen kosmeettisesta
        kunnosta (Grade A, B tai C).
        <br><br>
        6.2. Jos laitteen tila tai tekniset tiedot poikkeavat asiakkaan alun perin antamista tiedoista,
        Danghuan Europe S.L. lähettää asiakkaalle sähköpostitse uuden, korjatun tarjouksen,
        jossa ilmoitetaan päivitetty luokitus ja muutoksen peruste.
        <br><br>
        6.3. Asiakkaalla on 7 kalenteripäivää ilmoituspäivästä lukien hyväksyä tai hylätä korjattu
        tarjous. Tänä aikana asiakas voi halutessaan pyytää laitteensa palauttamista.
        <br><br>
        • Espanjassa asuvat asiakkaat: Danghuan Europe S.L. kattaa
        palautuskustannukset.
        <br><br>
        • Muiden maiden asiakkaat: Asiakas vastaa palautuskuluista enintään 22 €
        (GBP £19 / DKK 165 kr / SEK 245 kr, sis. ALV), käyttäen Danghuanin toimittamaa
        ennakkoon maksettua palautuslähetettä. Maksuohjeet toimitetaan Danghuanin
        toimesta sähköpostitse tai maksulinkin kautta.
        <br><br>
        Palautusmaksu voidaan suorittaa seuraavasti:
        <br><br>
        • EU-/ETA-asiakkaat: SEPA-pankkisiirrolla Danghuanin IBAN-tilille.
        <br><br>
        • UK-asiakkaat: GBP-pankkisiirrolla Danghuanin brittiläiselle pankkitilille (Faster
        Payments tai BACS).
        <br><br>
        Jos maksua ei vastaanoteta 10 kalenteripäivän kuluessa maksupyynnön
        lähettämisestä, Danghuan pidättää oikeuden katsoa korjattu tarjous hyväksytyksi ja
        käsitellä laitteen sen mukaisesti.
        <br><br>
        Asiakkaan maksamat palautuskulut hyvitetään 5 arkipäivän kuluessa maksun
        vahvistamisesta ja palautus suoritetaan samalle pankkitilille, joka on annettu vaihto-
        ohjelman rekisteröinnin yhteydessä.
        <br><br>
        6.4. Jos asiakas ei vastaa korjattuun tarjoukseen 7 kalenteripäivän kuluessa,
        Danghuanin asiakaspalvelu yrittää ottaa suoraan yhteyttä hyväksynnän tai hylkäyksen
        vahvistamiseksi. Jos vastausta ei saada 30 kalenteripäivän kuluessa ilmoituksesta,
        tarjous katsotaan hylätyksi. Asiakkaille Espanjan ulkopuolella sovelletaan tällöin
        palautusmaksua, joka on maksettava 5 kalenteripäivän kuluessa maksupyynnöstä. Kun
        maksu on vahvistettu, Danghuan järjestää palautuksen 5 arkipäivän kuluessa ja
        toimittaa asiakkaalle sähköpostitse vahvistuksen sekä seurantatiedot.
        <br><br>
        6.5. Laitteet, joissa on vakavia vaurioita, manipulaatioita tai kelpaamattomuuksia (esim.
        iCloud-lukitus, varastettu laite tai virheellinen IMEI), eivät saa arvoa. Asiakas voi pyytää
        palautusta 7 kalenteripäivän kuluessa ilmoituksesta; muussa tapauksessa laite
        kierrätetään vastuullisesti.
        <br><br>
        6.6. Hyväksytyistä laitteista maksetaan hyvitys 3 arkipäivän kuluessa hyväksynnästä
        SEPA-pankkisiirtona.
        <br><br>
        6.7. Laitteiden kuntoluokitukset
        <br><br>
        Jokainen laite arvioidaan ja luokitellaan seuraavasti. Eri tuoteryhmillä (smartphone,
        tablet, smartwatch, earbuds) on omakohtaiset kriteerit:
        <br><br>
        I. Älypuhelimet ja tabletit
        <br><br>
        Grade A – Erinomainen kunto
        <br><br>
        • Laite on hyvässä kunnossa, vain vähäisiä käyttöjälkiä.
        <br><br>
        • Ei halkeamia, kolhuja tai maalin kulumaa.
        <br><br>
        • Kaikki toiminnot (näyttö, kosketus, kamera, painikkeet, kaiutin, akku, yhteydet
        jne.) toimivat normaalisti.
        <br><br>
        • Apple-laitteissa akun terveys ≥ 90 %.
        <br><br>
        Grade B – Lievät käyttöjäljet
        <br><br>
        • Laite on hyvässä kunnossa, mutta siinä voi olla 2–3 pientä naarmua tai kevyttä
        kulumaa.
        <br><br>
        • Ei merkittäviä vaurioita.
        <br><br>
        • Kaikki päätoiminnot näyttö, kosketus, sensorit ja Bluetooth toimivat normaalisti.
        <br><br>
        • Apple-laitteissa akun terveys ≥ 80 %.
        <br><br>
        Grade C – Selkeät käyttöjäljet
        <br><br>
        • Laitteessa on näkyvää kulumaa, useita naarmuja, maalin kulumista tai pieni
        painauma.
        <br><br>
        • Kevyt näytön halkeama on hyväksyttävä, jos se ei vaikuta toimintaan.
        <br><br>
        • Kaikki keskeiset toiminnot toimivat yhä.
        <br><br>
        Grade D – Ei hyväksyttävissä / Hylätty
        <br><br>
        • Laite on vakavasti vaurioitunut tai ei käynnisty.
        <br><br>
        • Syviä halkeamia, vääntynyt runko, rikki oleva näyttö tai kuori, puuttuvia osia,
        emolevyvika, korroosio tai ei kosketusvastetta.
        <br><br>
        • Ei voida testata (esim. lukittu Google/iCloud/PIN).
        <br><br>
        • Laitteen akku on turvonnut tai siinä on muita turvallisuusstandardeja
        täyttämättömiä ongelmia, kuten liiallista ylikuumenemista tai akun pullistama
        kuori.
        <br><br>
        II. Älykellot ja rannekkeet
        <br><br>
        Grade A – Erinomainen kunto
        <br><br>
        • Laite osoittaa vain vähäisiä käytön merkkejä ja on yleisesti hyvässä kunnossa.
        <br><br>
        • Ei halkeamia, maalin kulumista tai värimuutoksia.
        <br><br>
        • Kaikki toiminnot (kosketus, kruunu, sensorit, Bluetooth ja Wi-Fi) toimivat
        moitteettomasti.
        <br><br>
        • Apple-laitteissa akun terveys ≥ 90 %.
        <br><br>
        Grade B – Lievät käyttöjäljet
        <br><br>
        • Laite osoittaa normaaleja käytön merkkejä, mutta on yleisesti hyvässä kunnossa.
        <br><br>
        • Siinä voi olla 2–3 pientä naarmua tai lievää kulumaa, mutta ei merkittäviä
        vaurioita.
        <br><br>
        • Kaikki päätoiminnot (näyttö, kosketus, sensorit, Bluetooth) toimivat normaalisti.
        <br><br>
        • Apple-laitteissa akun terveys on vähintään 80 %.
        <br><br>
        Grade C – Selkeät käyttöjäljet
        <br><br>
        • Näkyvää kulumaa, pieniä painaumia tai värin haalistumista.
        <br><br>
        • Jotkin sensorit tai painikkeet voivat reagoida heikommin, mutta ydintoiminnot
        toimivat.
        <br><br>
        • Akun kesto lievästi heikentynyt (< 80 %).
        <br><br>
        Grade D – Ei hyväksyttävissä / Hylätty
        <br><br>
        • Laitteessa on vakava vaurio tai sitä ei voi käynnistää.
        <br><br>
        • Rikkoutunut näyttö, toimimattomat painikkeet tai kruunu, emolevyvika, tililukitus
        (iCloud/Google/PIN) tai korroosio.
        <br><br>
        • Ei kelpaa vaihto-ohjelmaan.
        <br><br>
        III. Langattomat kuulokkeet
        <br><br>
        Grade A – Erinomainen kunto
        <br><br>
        • Laite on erinomaisessa kunnossa, puhdas ja vapaa naarmuista tai tahroista.
        <br><br>
        • Kaikki toiminnot (ääni, kosketus, mikrofoni, Bluetooth, lataus) toimivat
        moitteettomasti.
        <br><br>
        • Latauskotelo on ehjä ja täysin toimintakunnossa.
        <br><br>
        Grade B – Lievät käyttöjäljet
        <br><br>
        • Laite osoittaa lieviä käytön merkkejä, kuten pieniä pintanaarmuja tai kevyttä
        kulutusta, mutta on yleisesti hyvässä kunnossa.
        <br><br>
        • Äänenlaatu on normaali, Bluetooth-yhteys vakaa ja latauskotelossa voi olla
        pieniä käytön jälkiä.
        <br><br>
        • Kosketus- ja mikrofonitoiminnot toimivat normaalisti.
        <br><br>
        Grade C – Selkeät käyttöjäljet
        <br><br>
        • Laite osoittaa näkyvää kulumaa, kuten useita naarmuja, värin haalistumista tai
        pieniä painaumia.
        <br><br>
        • Ääni tai mikrofoni voi olla lievästi heikentynyt, mutta toimiva.
        <br><br>
        • Bluetooth-yhteys saattaa olla epävakaampi, ja latauskotelossa voi olla näkyviä
        naarmuja tai lieviä vaurioita.
        <br><br>
        Grade D – Ei hyväksyttävissä / Hylätty
        <br><br>
        • Laite on epätäydellinen, ei käynnisty tai sen perustoiminnot eivät toimi.
        <br><br>
        • Puuttuva kuuloke tai latauskotelo, akkuvika, rikki oleva latausportti, Bluetooth-
        yhteyttä ei voi muodostaa tai vesivaurio.
        <br><br>
        • Ei kelpaa vaihto-ohjelmaan.
        <br><br>
        6.8. Jos vastaanotettu laite ei vastaa asiakkaan ilmoittamaa mallia tai sarjanumeroa,
        Danghuan ottaa yhteyttä asiakkaaseen ja toimittaa uuden tarjouksen. Jos laite on
        kelpoinen vaihto-ohjelmaan, uusi arvio annetaan sen todellisen kunnon perusteella.
        <br><br>
        Asiakkaan on hyväksyttävä päivitetty tarjous ja allekirjoitettava Omistajuus- ja
        rehellisyysvakuutus, ennen kuin vaihto voidaan viimeistellä.
        <br><br>
        Jos tarjousta ei hyväksytä 7 päivän kuluessa, asiakas voi pyytää palautusta artiklan 6.3
        mukaisesti.
        <br><br>
        6.9. Vaihto-ohjelmaan osallistuminen edellyttää, että asiakas toimittaa allekirjoitetun
        Omistajuus- ja rehellisyysvakuutuksen. Jos asiakirjaa ei täytetä tai allekirjoiteta
        asianmukaisesti, vaihto voidaan hylätä. Tällöin laite voidaan palauttaa asiakkaan
        pyynnöstä artiklan 6.3 mukaisesti tai kierrättää vastuullisesti, jos vastausta ei
        vastaanoteta määräajassa.
        <br><br>
        6.10. Alkuperäinen tarjous on voimassa 10 kalenteripäivää uuden ONEPLUS-laitteen
        toimituksesta. Tänä aikana vaihto voidaan suorittaa ilman muutoksia tarjottuun
        summaan. Määräajan jälkeen tarjousta voidaan muokata markkinahintojen muutosten
        takia, erityisesti korkean arvon tai taittuvanäyttöisten laitteiden osalta, joiden arvo voi
        vaihdella nopeasti.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 7 – MAKSUEHDOT</strong>
        <br><br>
        7.1. Maksut suoritetaan yksinomaan pankkisiirtona asiakkaan nimissä olevalle tilille, joka
        on ilmoitettu vaihto-ohjelmaan rekisteröitymisen yhteydessä.
        <br><br>
        7.2. EU- tai ETA-alueella asuville asiakkaille maksut suoritetaan SEPA-siirtona IBAN-
        tilille, joka on liitetty voimassa olevaan rahoituslaitokseen SEPA-alueella.
        <br><br>
        7.3. Yhdistyneessä kuningaskunnassa asuville asiakkaille maksut suoritetaan GBP-
        valuutassa joko Faster Payments- tai BACS-siirtona asiakkaan brittiläiselle pankkitilille,
        edellyttäen että tilitiedot ovat oikein ja tili on asiakkaan nimissä.
        <br><br>
        7.4. Ennakkoladattuja kortteja, virtuaalitilejä tai pankkitilejä, jotka eivät ole asiakkaan
        nimissä, ei hyväksytä, ja tällaiset maksut voivat johtaa vaihto-operaation peruuttamiseen.
        <br><br>
        7.5. Danghuan Europe S.L. ei ole vastuussa viivästyksistä tai virheistä, jotka johtuvat
        puutteellisista, virheellisistä tai vanhentuneista pankkitiedoista.
        <br><br>
        7.6. Jos asiakas ilmoittaa virheelliset tai epäkelvot tilitiedot ja maksu suoritetaan
        onnistuneesti kyseiselle tilille, Danghuan Europe S.L. ei ole vastuussa mahdollisesta
        <br><br>
        rahallisesta menetyksestä. Asiakas vastaa itse pankkitietojensa oikeellisuudesta. Toista
        maksua ei tällöin suoriteta.
        <br><br>
        7.7. Kun vaihto-ohjelmaprosessi on suoritettu loppuun ja palautettava summa on
        pienempi kuin mahdollinen vaihtobonus, maksetaan asiakkaalle vain jäljellä oleva
        palautettava osuus.
        <br><br>
        7.8. Jos uusi ONEPLUS-tuote palautetaan ja kauppa perutaan, vaihtobonus mitätöidään.
        <br><br>
        7.9. Kaikki vaihto-ohjelman maksuihin liittyvät pankkikulut maksaa Danghuan Europe S.L.
        <br><br>
        7.10. Huomioithan, että asiakkaalle maksettava kokonaismäärä voi koostua kahdesta
        erillisestä maksusta:
        <br><br>
        (a) Vaihtolaitteen arvioitu arvo, jonka maksaa Danghuan; ja
        <br><br>
        (b) ONEPLUSin mahdollinen kampanjabonus, joka maksetaan erikseen asiakkaan
        ilmoittamalle samalle pankkitilille.
        <br><br>
        Nämä kaksi maksua voivat saapua eri aikaan, riippuen kummankin osapuolen
        käsittelyajoista.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 8 – VASTUU JA MENETYKSEN RISKI</strong>
        <br><br>
        8.1. Asiakkaan on käytettävä Danghuan Europe S.L.:n toimittamaa ennakkoon
        maksettua lähetysetikettiä ja määrättyä logistiikkapalveluntarjoajaa. Muiden
        kuljetuspalveluiden käyttö mitätöi mahdollisen kuljetusvastuun ja korvaussuojan.
        <br><br>
        8.2. Laite katsotaan kadonneeksi, jos sitä ei ole seurattu, vahvistettu tai vastaanotettu
        Danghuan Europe S.L.:n toimesta 15 kalenteripäivän kuluessa sen luovutuksesta
        kuljetuspalvelulle.
        <br><br>
        • UPS-lähetyksissä mahdolliset reklamaatiot on tehtävä 60 päivän kuluessa
        lähetysetiketin luomisesta.
        <br><br>
        • CORREOS-lähetyksissä (Espanjan sisäiset) reklamaatiot on tehtävä
        mahdollisimman pian, mieluiten 15 päivän sisällä, ja viimeistään 1 vuoden
        kuluessa lähetyspäivästä.
        <br><br>
        Danghuan avustaa asiakasta kuljetusyhtiölle tehtävän reklamaation käsittelyssä.
        Prosessi kestää yleensä 30–60 päivää.
        <br><br>
        8.3. Tämä vastuusääntö koskee sekä asiakkaalta Danghuanille että Danghuanilta
        asiakkaalle suuntautuvia lähetyksiä.
        <br><br>
        8.4. Jos vahvistettu katoaminen tapahtuu Danghuanin logistiikkajärjestelmässä,
        Danghuan Europe S.L. auttaa asiakasta tekemään virallisen korvausvaatimuksen
        kuljetuspalvelulle.
        <br><br>
        8.5. Vastuu ja mahdollinen korvaus rajoittuvat yksinomaan tapauksiin, joissa asiakas on
        käyttänyt Danghuanin toimittamaa virallista lähetysetikettiä, ja joissa lähetyksen kulku
        voidaan todentaa seurannalla.
        <br><br>
        8.6. Hyväksytyissä katoamistapauksissa korvauksen määrä ei voi ylittää laitteen
        lopullista arvioitua vaihtohintaa, joka on määritetty ennen katoamisen vahvistamista.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 9 – HENKILÖTIEDOT JA TIETOSUOJAN NOUDETTAVUUS</strong>
        <br><br>
        9.1. Kaikkia asiakkaan vaihto-ohjelman yhteydessä antamia henkilötietoja käsitellään
        täysin sovellettavan tietosuojalainsäädännön mukaisesti, mukaan lukien Euroopan
        parlamentin ja neuvoston asetus (EU) 2016/679 (yleinen tietosuoja-asetus, GDPR)
        sekä Ison-Britannian tietosuojalaki (UK GDPR ja Data Protection Act 2018)
        Yhdistyneessä kuningaskunnassa asuvien asiakkaiden osalta. Danghuan Europe S.L.
        toimii rekisterinpitäjänä ja toteuttaa asianmukaiset tekniset ja organisatoriset
        toimenpiteet kaikkien henkilötietojen luottamuksellisuuden, eheyden ja turvallisuuden
        varmistamiseksi vaihto-ohjelman käsittelyn aikana.
        <br><br>
        9.2. Käsiteltäviin tietoihin sisältyy muun muassa: asiakkaan nimi, sähköpostiosoite,
        postiosoite, puhelinnumero, pankkitiedot, henkilöllisyystodistus, IMEI-numero sekä
        laitteen arviointilomakkeessa annetut vastaukset.
        <br><br>
        9.3. Tietoja käsitellään vain seuraaviin tarkoituksiin: asiakkaan henkilöllisyyden
        varmentamiseen, vaihtoarvion käsittelyyn ja arviointiin, laitteen kuljetuksen ja
        palautuksen hallintaan, asiakastuen tarjoamiseen, kirjanpidon ja maksujen
        toteuttamiseen. Henkilötietoja ei käytetä markkinointitarkoituksiin, eikä niitä luovuteta
        kolmansille osapuolille ilman asiakkaan nimenomaista suostumusta, ellei lainsäädäntö
        sitä edellytä.
        <br><br>
        9.4. Tietoja säilytetään vain niin kauan kuin on tarpeen vaihto-ohjelman suorittamiseksi
        ja lakisääteisten velvoitteiden täyttämiseksi. Ellei toisin vaadita, kaikki asiakastiedot
        poistetaan 30 päivän kuluessa vaihto-ohjelman ja maksun päättymisestä. Joissakin
        tapauksissa tietoja voidaan säilyttää enintään 90 päivää, jos se on tarpeen lakisääteisten
        tarkastusten, maksujen täsmäytyksen, petostutkinnan tai brändikumppaneiden
        auditointien vuoksi.
        <br><br>
        9.5. Asiakas on yksin vastuussa kaikkien henkilökohtaisten tietojen poistamisesta
        laitteesta ennen sen lähettämistä, mukaan lukien yhteystiedot, viestit, kuvat, sovellukset,
        sähköpostit, selaushistoria ja tilitiedot.
        <br><br>
        9.6. Asiakkaan on myös poistettava kaikki SIM- ja muistikortit sekä poistettava käytöstä
        kaikki suojaus- ja tililukitukset (kuten iCloud, Google- tai Samsung-tili). Jos laitteessa on
        aktiivinen lukitus tai tietoja ei ole poistettu, laite voidaan hylätä vaihto-ohjelmasta.
        <br><br>
        9.7. Lisätietoja henkilötietojen käsittelystä ja asiakkaan oikeuksista (oikeus tarkastaa,
        oikaista, poistaa tai rajoittaa tietojen käsittelyä) on saatavilla Danghuan Europe S.L.:n
        virallisesta tietosuojaselosteessa, joka löytyy yrityksen verkkosivustolta.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 10 – PETOS- JA RIKKOMUSKÄYTÄNTÖ</strong>
        <br><br>
        10.1. Tapaukset, joissa ilmoitettu tieto on virheellinen tai joissa laite on mustalla listalla,
        vuokrattu, manipuloitu tai ei asiakkaan omistuksessa, hylätään ilman korvausta.
        <br><br>
        10.2. Danghuan Europe S.L. pidättää oikeuden sulkea tällaiset asiakkaat pois nykyisistä
        ja tulevista vaihto-ohjelmista.
        <br><br>
        10.3. Jos ilmenee petosta, henkilöllisyysvarkautta tai yritys kiertää kelpoisuusehtoja
        kaupallisessa tarkoituksessa, Danghuan Europe S.L. voi ryhtyä oikeudellisiin
        toimenpiteisiin sovellettavan lain mukaisesti.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 11 – YLIVOIMAINEN ESTE</strong>
        <br><br>
        11.1. Jos tapahtuu olosuhteita, joihin Danghuan Europe S.L. ei voi kohtuudella vaikuttaa
        – kuten luonnonkatastrofi, hallinnollinen rajoitus, pandemia, työtaistelu tai kuljetushäiriö
        – yritys voi väliaikaisesti keskeyttää vaihto-ohjelmapalvelun ilman vastuuta.
        <br><br>
        11.2. Kaikki viivästykset tai suorituksen laiminlyönnit, jotka johtuvat tällaisista
        ylivoimaisista esteistä, eivät muodosta sopimusrikkomusta.
        <br><br>
        <strong style="font-size: 20px; font-weight: 800;">ARTIKLA 12 – SOVELLETTAVA LAKI JA TOIMIVALTAINEN TUOMIOISTUIN</strong>
        <br><br>
        12.1. Näihin ehtoihin sovelletaan ja niitä tulkitaan Espanjan lain mukaisesti. Tämä ei
        rajoita asiakkaan oikeuksia saada suojaa oman asuinmaansa pakottavan
        kuluttajansuojalainsäädännön nojalla.
        <br><br>
        12.2. Kaikki näihin ehtoihin tai niiden soveltamiseen liittyvät riidat kuuluvat Espanjan,
        Madridin tuomioistuinten yksinomaiseen toimivaltaan, mikä ei kuitenkaan rajoita
        asiakkaan oikeutta saattaa asia oman asuinmaansa kuluttajansuojaa valvovan
        viranomaisen tai tuomioistuimen käsiteltäväksi.
      </div>
    </div>
  </div>
`;